import { render, staticRenderFns } from "./Effect.vue?vue&type=template&id=53bfb866&lang=pug"
import script from "./Effect.vue?vue&type=script&lang=js"
export * from "./Effect.vue?vue&type=script&lang=js"
import style0 from "./Effect.vue?vue&type=style&index=0&id=53bfb866&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports